import { Component, ErrorInfo, ReactNode } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface Props extends WithTranslation {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryBase extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary:', error, info.componentStack);
  }

  private handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    const { t, children } = this.props;

    if (this.state.hasError) {
      return (
        <div className="async-state async-state--error" role="alert">
          <p className="async-state__title">{t('common.unexpectedError')}</p>
          <p className="async-state__message">{t('common.unexpectedErrorHint')}</p>
          <button type="button" className="async-state__action" onClick={this.handleRetry}>
            {t('common.retry')}
          </button>
        </div>
      );
    }

    return children;
  }
}

export const ErrorBoundary = withTranslation()(ErrorBoundaryBase);
